import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class RoundedRectangleConfiguration implements ShapeConfigurationInterface {
	use_individual_corners(): boolean {
		const { pricingGroup } = window.measurementSelectorVariables;

		return pricingGroup.shape_settings[ 'rounded-rectangle' ][ 'use_individual_corners' ] ?? false;
	}

	get_dimension_keys(): string[] {
		if ( this.use_individual_corners() ) {
			return [
				'length',
				'width',
				'top_left_radius',
				'top_right_radius',
				'bottom_left_radius',
				'bottom_right_radius',
			];
		}

		return [
			'length',
			'width',
			'radius',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle, dimensions ): Record<string, Length> {
		const maxRadius = Length.from_cm( dimensions.width ).min( Length.from_cm( dimensions.length ) ).divide( 2 );

		return {
			length: maximum_rectangle.get_length(),
			width: maximum_rectangle.get_width(),
			radius: maxRadius,
			'top_right_radius': maxRadius,
			'bottom_right_radius': maxRadius,
			'bottom_left_radius': maxRadius,
			'top_left_radius': maxRadius,
		};
	}

	get_labels(): Record<string, string> {
		const { length, width, radius, top_right_radius, bottom_right_radius, bottom_left_radius, top_left_radius, height } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			length,
			width,
			radius,
			top_right_radius,
			bottom_right_radius,
			bottom_left_radius,
			top_left_radius,
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			length: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			radius: [ MaximumDecimalPoints, MaximumValue ],
			'top_right_radius': [ MaximumDecimalPoints, MaximumValue ],
			'bottom_right_radius': [ MaximumDecimalPoints, MaximumValue ],
			'bottom_left_radius': [ MaximumDecimalPoints, MaximumValue ],
			'top_left_radius': [ MaximumDecimalPoints, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
